/**
 * Adzuki.Maps
 */

(function GoogleMaps($, Adzuki)
{
	"use strict";

	// init a GoogleMap on your element of choice
	var map = function GoogleMap(el, options)
	{
		var defaults = {
			zoom: 10,
			lat : 0,
			lng : 0,
		};

		var self   = this,
		    opts   = $.extend({}, defaults, options),
			styles = null;

		if (typeof opts.styles !== 'undefined') {
			styles = opts.styles;
		} 

		try
		{
			// enforce 'new' operator to ensure 'this' points to this
			// instance, instead of the global window object
			if ((this instanceof GoogleMap) === false) {
				throw new Error("Error instantiating map: missing 'new' operator.");
				// return new GoogleMap(el, options);
			}

			if (typeof google.maps !== 'object') {
				throw new Error('Google Maps library is not loaded!');
			}

			if (typeof el === 'string') {
				this.mapElement = $(el)[0];
			}
			else if (typeof el === 'object' && (el instanceof jQuery)) {
				this.mapElement = el[0];
			}

			if (this.mapElement === undefined) {
				throw new Error("'el' is not a valid selector or jQuery object.");
			}

			if ($(this.mapElement).height() === 0) {
				throw new Error("map element has no height!");
			}

			// for identifying via css
			$(this.mapElement).addClass('adzuki-map');

			this.mapMarkers        = [];
			this.lastMapInfoWindow = {};
			this.selectedMarker    = {};
			this.markerCallback    = function noop() { /**/ };
			this.mapBounds         = new google.maps.LatLngBounds();
			this.map               = new google.maps.Map(this.mapElement, {
				zoom  : opts.zoom,
				styles: styles,
				center: {
					lat: opts.lat,
					lng: opts.lng
				}
			});

			this.icons             = {
				restaurant: 'rec_dining',
				hotel     : 'rec_lodging',
				car       : 'cabs',
				air       : 'airports',
				cruise    : 'sea_ports',
				tour      : 'binoculars',
				activity  : 'flag',
			};

			google.maps.event.addListenerOnce(this.map, 'idle', function mapReady() {
				if (typeof opts.init === 'function') {
					opts.init(self);
				}
			});
		}
		catch (err)
		{
			console.error('[Adzuki.Map]', err);
		}
	};


	/**
	 * Populate the map with markers
	 */
	map.prototype.populate = function populate(markers, shouldFitBounds)
	{
		var self             = this,
		    _shouldFitBounds = (shouldFitBounds !== false),
			i;

		try
		{
			if (typeof markers !== "object") {
				throw new Error('Invalid markers object.');
			}

			// clear existing map bounds
			this.mapBounds = new google.maps.LatLngBounds();

			for (i in markers) {
				if ({}.hasOwnProperty.call(markers, i)) {
					self._createMarker(markers[i]);
					// self.mapMarkers.push(_marker);
					// self.mapBounds.extend(_marker.getPosition());
				}
			}

			if (_shouldFitBounds) {
				if (markers.length > 1) {
					// fit the map around all available markers
					self.map.fitBounds(this.mapBounds);
				}
				else {
					// fit the map around the one marker using the initial
					// zoom level (either default or passed in as an arg)
					self.map.setCenter(this.mapBounds.getCenter());
				}

			}
		}
		catch (err) {
			console.error('[Adzuki.Map]', err);
		}
	};

	/**
	 * Enables search box
	 */
	map.prototype.enableSearch = function enableSearch()
	{
		var self  = this,
		    input = document.createElement('input'),
		    searchBox;

		input.type      = "text";
		input.className = "google-control";

		searchBox = new google.maps.places.SearchBox(input);
		self.map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);

		// bias search results in current viewport
		// this.map.addListener('bounds_changed', function boundsChanged() {
		// 	searchBox.setBounds(self.map.getBounds());
		// });

		searchBox.addListener('places_changed', function placesChanged() {
			var places = searchBox.getPlaces();
			self.map.setCenter(new google.maps.LatLng(places[0].geometry.location.lat(), places[0].geometry.location.lng()));
		});
	};

	/**
	 * Enables user markers (click on the map to drop the marker)
	 */
	map.prototype.enableUserMarkers = function enableUserMarkers(options)
	{
		var self = this,
		    opts = options || {},
		    error_msg;

		google.maps.event.addListener(self.map, 'click', function _userMarker(e)
		{
			if (opts.max !== undefined && opts.max <= self.mapMarkers.length)
			{
				// eslint-disable-next-line no-magic-numbers
				error_msg = "This map only supports up to " + (opts.max || 1)
					+ " marker(s).<hr>To remove a marker you have placed, "
					+ "double-click on it.";

				// using $.alert directly because Adzuki.StatusMessage
				// doesn't get pulled in until after Adzuki.Maps, because
				// of silly reasons such as alphabetical order of compilation.
				$.alert({
					title            : 'Error',
					content          : error_msg,
					icon             : Adzuki.FaIcon.getIconStyle('exclamation'),
					backgroundDismiss: true,
					onOpen           : function dim() {
						this.$body.addClass('adzuki-status error');
					}
				});

				return;
			}

			self._createUserMarker(e);
		});
	};

	/**
	 * Destroys all map markers and clears internal tracking
	 */
	map.prototype.destroyAllMarkers = function destroyAllMarkers()
	{
		var i, len;

		/* eslint-disable no-magic-numbers */
		for (i = 0, len = this.mapMarkers.length; i < len; i++)
		{
			this.mapMarkers[i].setMap(null);
		}

		this.mapMarkers = [];
		/* eslint-enable no-magic-numbers */
	};

	/**
	 * Draw guide lines between markers
	 */
	map.prototype.drawGuidelines = function drawGuidelines(markers)
	{
		var coords,
		    path;

		// eslint-disable-next-line no-magic-numbers
		if (this.mapMarkers.length <= 1) {
			return;
		}

		// google.maps.Polyline needs real number-types,
		// unlike google.maps.Marker which accepts numbers-as-strings
		coords = this.mapMarkers.map(function convertLatLng(marker)
		{
			return {
				lat: parseFloat(marker.lat),
				lng: parseFloat(marker.lng)
			};
		});

		path = new google.maps.Polyline({
			path         : coords,
			geodesic     : true,
			strokeColor  : '#40C5C5',
			strokeOpacity: 1,
			strokeWeight : 5,
		});

		path.setMap(this.map);
	};

	/**
	 * Select (click) a specific marker
	 */
	map.prototype.selectMarker = function selectMarker(marker_id, click)
	{
		this.map.panTo(this.mapMarkers[marker_id].getPosition());

		if (click !== false) {
			google.maps.event.trigger(this.mapMarkers[marker_id], 'click');
		}
	};

	/**
	 * Fits all markers into the map viewport
	 */
	map.prototype.viewAllMarkers = function viewAllMarkers()
	{
		this.map.fitBounds(this.mapBounds);
	};


	/**
	 * Centers the map on a specified area
	 */
	map.prototype.panTo = function panTo(lat, lng, zoom)
	{
		var _lat   = parseFloat(lat),
		    _lng   = parseFloat(lng),
		    // eslint-disable-next-line no-magic-numbers
		    _zoom  = zoom || 10; // default zoom level

		this.lastMapInfoWindow.close();
		this.map.panTo(new google.maps.LatLng(_lat, _lng));
		this.map.setZoom(_zoom);
	};


	/**
	 * Creates an individual marker
	 */
	map.prototype._createMarker = function _createMarker(marker)
	{
		var _marker, _data;

		if (marker.lat === undefined || marker.lng === undefined) {
			throw new Error('marker has undefined lat or lng');
		}

		// Use standard marker if no price
		if ('price' in marker) {
			// Create a custom overlay for the price marker
			let CustomMarker = function _CustomMarker(latlng, map, price) {
				this.latlng = latlng;
				this.price = price;
				this.setMap(map);
			};

			CustomMarker.prototype = new google.maps.OverlayView();

			CustomMarker.prototype.onAdd = function _onAdd() {
				// Create marker container
				let container = document.createElement('div');
				container.className = 'marker-container';

				// Create price bubble
				let div = document.createElement('div');
				div.className = 'price-marker';
				div.innerHTML = this.price > 0 ? '$' + this.price: 'Hotel Unavailable';

				// Add elements to container
				container.appendChild(div);

				// Save reference to this for use in listeners
				let self = this;

				// Add click event to the custom marker
				google.maps.event.addDomListener(container, 'click', function _markerClick() {
					google.maps.event.trigger(self, 'click');
				});

				this.div = container;
				let panes = this.getPanes();
				panes.overlayMouseTarget.appendChild(container);
			};

			CustomMarker.prototype.draw = function _draw() {
				var overlayProjection = this.getProjection();
				var position = overlayProjection.fromLatLngToDivPixel(this.latlng);

				var div = this.div;
				// Position the container at the exact location (no need to offset for pointer)
				div.style.left = (position.x - 20) + 'px';
				div.style.top = (position.y - 30) + 'px'; // Adjusted since we no longer have a pointer

				// Add explicit styling to make the markers visible
				div.style.position = 'absolute';
				div.style.zIndex = '1000';

				// Style the price marker to be navy blue with white text
				let priceMarker = div.querySelector('.price-marker');
				if (priceMarker) {
					priceMarker.style.backgroundColor = '#003366'; // Navy blue
					priceMarker.style.color = 'white';
					priceMarker.style.padding = '5px 10px';
					priceMarker.style.borderRadius = '4px';
					priceMarker.style.fontWeight = 'bold';
					priceMarker.style.display = 'inline-block';
					priceMarker.style.minWidth = '40px';
					priceMarker.style.textAlign = 'center';
				}
			};

			CustomMarker.prototype.onRemove = function _onRemove() {
				this.div.parentNode.removeChild(this.div);
				this.div = null;
			};

			// Create the custom marker
			_marker = new CustomMarker(
				new google.maps.LatLng(marker.lat, marker.lng),
				this.map,
				marker.price
			);

			// Store original marker data for info window
			_marker.title = marker.title || 'Untitled';
			_marker.content = marker.content;
		}
		// Use custom HTML marker with price
		else {

			_data = $.extend({}, marker, {
				map      : this.map,
				position : new google.maps.LatLng(marker.lat, marker.lng),
				animation: google.maps.Animation.DROP,
				title    : marker.title || 'Untitled',
			});

			_marker = new google.maps.Marker(_data);
		}

		// track new marker
		this.mapMarkers.push(_marker);

		// add it to map bounds for layout/zooming
		this.mapBounds.extend(new google.maps.LatLng(marker.lat, marker.lng));

		if ('price' in marker) {
			this._setupHeMarkerHandler(_marker);
		} else {
			this._setupMarkerHandler(_marker);
		}
		return _marker;
	};


	/**
	 * Creates an individual, user-placed marker
	 */
	map.prototype._createUserMarker = function _createUserMarker(event)
	{
		var self   = this,
		    marker = new google.maps.Marker({
		        position   : event.latLng,
		        map        : self.map,
		        user_placed: true,
		    });

		self.mapMarkers.push(marker);

		google.maps.event.addListener(marker, 'dblclick', function _destroyUserMarker(e)
		{
			self._destroyMarker(marker);
		});
	};


	/**
	 * Destroys an individual marker
	 */
	map.prototype._destroyMarker = function _destroyMarker(marker)
	{
		var i, len;

		/* eslint-disable no-magic-numbers */
		for (i = 0, len = this.mapMarkers.length; i < len; i++)
		{
			if (marker === this.mapMarkers[i])
			{
				this.mapMarkers.splice(i, 1);
				marker.setMap(null);
			}
		}
		/* eslint-enable no-magic-numbers */
	};


	/**
	 * Add listeners for click events on map markers
	 */
	map.prototype._setupMarkerHandler = function _setupMarkerHandler(marker)
	{
		var self = this;
		google.maps.event.addListener(marker, 'click', function clickMarker()
		{
			if (!$.isEmptyObject(self.lastMapInfoWindow)) {
				self.lastMapInfoWindow.close();
			}

			self.lastMapInfoWindow = new google.maps.InfoWindow({
				content: '<div class="map-marker">'
				            +'<h5>' + marker.title + '</h5>'
				            + (marker.content || 'No Content')
				         +'</div>'
			});

			self.selectedMarker = marker;
			self.lastMapInfoWindow.open(self.map, marker);
			self.markerCallback(marker);
		});
	};

	map.prototype._setupHeMarkerHandler = function _setupMarkerHandler(marker)
	{
		var self = this;
		google.maps.event.addListener(marker, 'click', function clickMarker()
		{
			if (!$.isEmptyObject(self.lastMapInfoWindow)) {
				self.lastMapInfoWindow.close();
			}

			self.lastMapInfoWindow = new google.maps.InfoWindow({
				content: '<div class="he-map-marker">'
					+'<h5>' + marker.title + '</h5>'
					+ (marker.content || 'No Content')
					+'</div>',
				maxWidth : 550,
				minHeight: 800,   // Increase the minimum height
				minWidth : 320    // Set a minimum width
			});

			self.selectedMarker = marker;

			// For custom markers, we need to position the info window manually
			if (marker instanceof google.maps.Marker) {
				self.lastMapInfoWindow.open(self.map, marker);
			} else {
				self.lastMapInfoWindow.setPosition(marker.latlng);
				self.lastMapInfoWindow.open(self.map);
			}

			// Add custom styling to the info window after it's opened
			google.maps.event.addListener(self.lastMapInfoWindow, 'domready', function _domReady() {
				// Target all the Google Maps InfoWindow elements

				// The main container
				$('.gm-style-iw-c').css({
					maxWidth : '450px',
					minHeight: '300px',
					padding  : '12px'
				});

				// The content container
				$('.gm-style-iw-d').css({
					overflow : 'auto',
					maxHeight: '600px',
					maxWidth : '430px'
				});

				// The outer container
				$('.gm-style-iw').css({
					maxWidth: '450px',
					width   : '100%'
				});

				// Remove any width restrictions on the content
				$('.gm-style-iw > div').css({
					maxWidth: 'none',
					width   : '100%'
				});

				// Improve the styling of the hotel details
				$('.map-marker').css({
					width  : '100%',
					padding: '5px'
				});

				// Make images responsive
				$('.map-marker img').css({
					maxWidth: '100%',
					height  : 'auto'
				});

				// Ensure text doesn't overflow
				$('.map-marker h5, .map-marker p').css({
					wordWrap: 'break-word'
				});
			});

			self.markerClickCallback(marker);

			// re-center map within bounds on infowindow close
			google.maps.event.addListener(self.lastMapInfoWindow, 'closeclick', function _closeInfoWindow() {
				console.log('no zoom out');
				// self.infoWindowCloseCallback(marker);
			});
		});
	};

	Adzuki.Map = map;
}(jQuery, window.Adzuki || {}));
